
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-material-design-icons/styles.css'
import 'bootstrap-vue/dist/bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import './assets/css/material-dashboard.min.css'
import './assets/css/styles.css'
import '@fortawesome/fontawesome-free/css/all.css'

import './assets/css/bumblebee-styles.css'
import './assets/css/training-styles.css'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n';
import HighchartsVue from 'highcharts-vue'
// import FullCalendar from 'vue-full-calendar'
import VueAxios from 'vue-axios'
import axios from 'axios'

import {
  Dataset,
  DatasetItem,
  DatasetInfo,
  DatasetPager,
  DatasetSearch,
  DatasetShow
} from 'vue-dataset'

// import VueFileAgent from 'vue-file-agent';


import MenuIcon from 'vue-material-design-icons/Menu.vue';
import DotsVerticalIcon from 'vue-material-design-icons/DotsVertical.vue';
import ViewListIcon from 'vue-material-design-icons/ViewList.vue';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import specific icons */
import {
  faMagnifyingGlass, faAngleLeft, faArrowRight, faTimes, faAdd, faCirclePlus, faExclamationCircle,
  faDownload, faPlay, faPause, faVolumeHigh, faVolumeMute, faForwardStep, faBackwardStep, faShuffle,
  faRepeat, faAngleDoubleLeft, faAngleDoubleRight, faSquarePlus, faSquarePen, faTrashCan, faCircleArrowRight,
  faLocationDot, faCircle, faCircleCheck, faEllipsisVertical, faUpload, faEye, faEyeSlash, faPen,
  faXmark, faHome, faArrowTrendDown, faArrowTrendUp, faChevronDown, faCheck, faCircleXmark, faPenToSquare,
  faPlus, faFloppyDisk, faPaperPlane, faFileLines, faCopy, faFileCirclePlus
}
  from '@fortawesome/free-solid-svg-icons'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSimpleAlert from "vue-simple-alert";
import VueFileAgent from 'vue-file-agent';
import Treeselect from '@riophae/vue-treeselect'
import VueTelInput from 'vue-tel-input';
import ToggleButton from 'vue-js-toggle-button'
import VueCoreVideoPlayer from 'vue-core-video-player'


import 'jquery/dist/jquery.min.js'
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import "vue-select/dist/vue-select.css";
import 'vue-file-agent/dist/vue-file-agent.css';
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import 'datatables.net-buttons/js/dataTables.buttons'
import 'datatables.net-buttons-dt/js/buttons.dataTables'
import 'datatables.net-buttons/js/buttons.colVis'
import 'datatables.net-buttons/js/buttons.flash'
import 'datatables.net-buttons/js/buttons.html5'
import 'datatables.net-buttons/js/buttons.print'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'

import 'vue-file-agent/dist/vue-file-agent.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import 'vue-tel-input/dist/vue-tel-input.css';

import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

import VueSlickCarousel from 'vue-slick-carousel'

import Select2 from 'v-select2-component';
import vSelect from "vue-select";
import VueSlider from 'vue-slider-component'
import Print from 'vue-print-nb'

const GOOGLE_API_KEY = 'AIzaSyD_o6JPA8HdonVYbtf_oHY7mpPBFBCe7Sw'
// const GOOGLE_API_KEY = 'AIzaSyDg8oDMkIGwPg-JHc86lxvX4SNce6TzjWs'
// import 'bootstrap-fileinput/css/fileinput.min.css'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: GOOGLE_API_KEY,
    libraries: 'places,geometry,drawing', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(HighchartsVue)
// Vue.use(FullCalendar)

Vue.use(vSelect)
Vue.use(VueSimpleAlert);
Vue.use(VueFileAgent);
Vue.use(VueTelInput, {
  defaultCountry: 'IE',
  preferredCountries: ['IE', 'GB','FR'],
  autoFormat: false,
  dropdownOptions: { showSearchBox: true },
  inputOptions: { placeholder: "Mobile number", showDialCode: true }
});
Vue.use(ToggleButton)
Vue.use(Print)
Vue.use(VueCoreVideoPlayer)

import ProgressBar from 'vuejs-progress-bar'
Vue.use(ProgressBar)

Vue.component('Select2', Select2);
// Vue.component("v-select", vSelect);
Vue.component('Dataset', Dataset)
Vue.component('DatasetItem', DatasetItem)
Vue.component('DatasetInfo', DatasetInfo)
Vue.component('DatasetPager', DatasetPager)
Vue.component('DatasetSearch', DatasetSearch)
Vue.component('DatasetShow', DatasetShow)

Vue.component('menu-icon', MenuIcon);
Vue.component('dots-vertical-icon', DotsVerticalIcon);
Vue.component('view-list-icon', ViewListIcon);
Vue.component('arrow-right-icon', ArrowRightIcon);

Vue.component('VueSlickCarousel', VueSlickCarousel)
Vue.component('Treeselect', Treeselect)

Vue.component('VueSlider', VueSlider);

/* add icons to the library */
library.add({
  faMagnifyingGlass, faAngleLeft, faArrowRight, faTimes, faAdd, faCirclePlus, faExclamationCircle,
  faDownload, faPlay, faPause, faVolumeHigh, faVolumeMute, faForwardStep, faBackwardStep, faShuffle,
  faRepeat, faAngleDoubleLeft, faAngleDoubleRight, faSquarePlus, faSquarePen, faTrashCan, faCircleArrowRight,
  faLocationDot, faCircle, faCircleCheck, faEllipsisVertical, faUpload, faEye, faEyeSlash, faPen, faXmark, faHome,
  faArrowTrendDown, faArrowTrendUp, faChevronDown, faCheck, faCircleXmark,faPenToSquare,
  faPlus, faFloppyDisk, faPaperPlane, faFileLines, faCopy, faFileCirclePlus
})
/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

import 'vue-slider-component/theme/antd.css'

// import "./components/my_irish_date/css/my-irish-date-fonts.css";
// import "./components/my_irish_date/css/my-irish-date-auth-styles.css";
// import "./components/my_irish_date/css/my-irish-date-styles.css";
// import "./components/my_irish_date/css/my-irish-date-buttons-styles.css";
// import "./components/my_irish_date/css/my-irish-date-calendar-styles.css";

axios.defaults.withCredentials = false
// axios.defaults.baseURL = 'https://microservices.bumblebeeai.io/api'
// axios.defaults.baseURL = 'https://microservices-staging.bumblebeeai.host/api/'
// axios.defaults.baseURL = 'https://pavio-back.bumblebeeai.io/api/'
axios.defaults.baseURL = 'https://pavio-back.311-solutions.com/api/'
// axios.defaults.baseURL = 'http://localhost:8000/api/'
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

import messages from './lang'

// const messages = {
//   en: {
//     message: {
//       value: 'This is an example of content translation.'
//     }
//   },
//   be: {
//     message: {
//       value: 'Гэта прыклад перакладу змесціва.'
//     }
//   },
//   da: {
//     message: {
//       value: 'Dette er et eksempel på oversættelse af indhold.'
//     }
//   },
//   hr: {
//     message: {
//       value: 'Ovo je primjer prevođenja sadržaja.'
//     }
//   }
// };

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router, i18n,
  components: { App },
  template: '<App/>'
})

const eventHub = new Vue() // Single event hub

// Distribute to components using global mixin
export var mixin = {

  eventHub: eventHub
}


// WEBPACK FOOTER //
// ./src/main.js